/* eslint-disable no-restricted-syntax */
/**
 * Error category item from the API
 * GET /api/v3/stt/error-categories
 */
export type ErrorCategoryItem = {
  key: string;
  label: string;
  description: string;
};

/**
 * Response from error categories endpoint
 */
export type ErrorCategoriesResponse = {
  categories: ErrorCategoryItem[];
};

/**
 * Styling configuration for error categories
 * Used for consistent visual presentation across the application
 */
export const ERROR_CATEGORY_STYLES: Record<
  string,
  { color: string; bg: string; label: string }
> = {
  file_issue: {
    color: '#EA580C',
    bg: 'rgba(234, 88, 12, 0.1)',
    label: 'File Issue'
  },
  timeout: {
    color: '#D97706',
    bg: 'rgba(217, 119, 6, 0.1)',
    label: 'Timeout'
  },
  server_error: {
    color: '#DC2626',
    bg: 'rgba(220, 38, 38, 0.1)',
    label: 'Server Error'
  },
  batch_failed: {
    color: '#DC2626',
    bg: 'rgba(220, 38, 38, 0.1)',
    label: 'Batch Failed'
  },
  resource_limit: {
    color: '#9333EA',
    bg: 'rgba(147, 51, 234, 0.1)',
    label: 'Resource Limit'
  },
  configuration: {
    color: '#2563EB',
    bg: 'rgba(37, 99, 235, 0.1)',
    label: 'Configuration'
  },
  client_error: {
    color: '#CA8A04',
    bg: 'rgba(202, 138, 4, 0.1)',
    label: 'Client Error'
  },
  unknown: {
    color: '#6B7280',
    bg: 'rgba(107, 114, 128, 0.1)',
    label: 'Unknown'
  }
};

/**
 * Get the display label for an error category
 */
export const getErrorCategoryLabel = (
  category: string | null | undefined
): string => {
  if (!category) return 'Unknown';
  return ERROR_CATEGORY_STYLES[category]?.label || category.replace(/_/g, ' ');
};

/**
 * Get styling for an error category
 */
export const getErrorCategoryStyle = (
  category: string | null | undefined
): { color: string; bg: string } => {
  if (!category) return ERROR_CATEGORY_STYLES.unknown;
  return ERROR_CATEGORY_STYLES[category] || ERROR_CATEGORY_STYLES.unknown;
};
